import { FormulaDecimal } from '@nexo/formula';

/** `value` at `scale` decimals, rounded half away from zero, as PostgreSQL rounds a numeric; unchanged when the scale is null. */
export function atScale(value: number, scale: number | null): number {
  if (scale === null) return value;
  return new FormulaDecimal(value).toDecimalPlaces(scale, FormulaDecimal.ROUND_HALF_UP).toNumber();
}

/** Whether `value` is stored as it is at `scale`: it carries no decimal the column would round away. */
export function fitsScale(value: number, scale: number | null): boolean {
  return atScale(value, scale) === value;
}
